import React from "react"
import { ErrorPage } from "./ErrorPage"

export const NotFoundPage: React.FC = () => {
	return (
		<ErrorPage
			title="404 Error"
			description="Sorry, page not found. The page you were looking for doesn’t exist."
		/>
	)
}
